import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'empie-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.scss']
})
export class LeadsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
